import { fromJS, List, Map } from 'immutable';
import pip from '@turf/boolean-point-in-polygon';
import { multiPolygon, point  } from '@turf/helpers';


function compareMultipleWords(stringArray, commaDelimitedString) {
  var result = false;
  if(commaDelimitedString === null) {
    return result;
  } else {
    commaDelimitedString.split(', ').forEach(function(word) {
      if(stringArray.indexOf(word) > -1) {
        result = true;
      }
    })
    return result;
  }
}

/* * * * * * * * * Apply Active Filters and Assign 'filteredData' * * * * * * * */
/* requires 'drawnPolygons' from MapApp and 'activeFilters' from FilterApp * * * */
const applyFilters = (state, action) => {
  var filteredData,
      activeFilters = action.activeFilters;

  var polygon = [];
  var polygons = [];
  if(action.drawnPolygons.size > 0) {
    activeFilters = activeFilters.set('polygons', Map({type: 'spatial'}));
    action.drawnPolygons.forEach(shape => {
      polygon = [];
      shape.get('coords').first().forEach(function(element, index, array) {
        polygon.push([element.lng, element.lat])
      })
      polygons.push([polygon]);
    })
    var multiPoly = multiPolygon(polygons);
  }

  var pt;
  if(activeFilters.size){

    filteredData = state.get('data').filter( (data_point) => {

      var include = true;
      activeFilters.forEach( (activeFilter, field) => {
        switch(activeFilter.get('type')){
            //discrete filters are listed in an array, if our value isn't in the array, don't include it.
            case 'discrete':
              if(activeFilter.get('filters').indexOf(data_point.get(field)) === -1 && !(compareMultipleWords(activeFilter.get('filters').toJS(), data_point.get(field)))) {
                include = false;
              }
            break;

            //interval filters come with a min and max in an array. If our value is outside that array, don't include it.
            case 'interval':
            if(+data_point.get(field) > activeFilter.get('filters').get(0).max() || +data_point.get(field) < activeFilter.get('filters').get(0).min()){
                include = false;
              }
            break;

            case 'spatial':
              pt = point([+data_point.get('longitude'), +data_point.get('latitude')])
              if(!pip(pt, multiPoly)) {
                include = false;
              }
            break;

            default:
              include = true;
        }
      });
      return include;
    })//.map( (data_point) => { return data_point.set('sample_date', moment(data_point.get('sample_date')).format('ll')) })

  } else { //if no active filters, show all data
    filteredData = state.get('data')//.map( (data_point) => { return data_point.set('sample_date', moment(data_point.get('sample_date')).format('ll')) })
  }
  return state.set('filteredData', filteredData)
}

// now filter properties based on data -- if TMK in filteredData.
const applyFilteredData = (state, action) => {
  var tmks = state.get('filteredData').map(x => x.get('cty_tmk'))
  //var filteredProperties = state.get('properties').filter(x => tmks.includes(x.get('tmk')))
  var filteredProperties = state.get('properties').get('features').map(x => {
    if(tmks.includes(x.get('properties').get('cty_tmk'))) {
    //if(tmks.includes(x.get('properties').get('cty_tmk')) && state.get('data').filter(y => y.get('cty_tmk') === x.get('properties').get('cty_tmk')).get(0).get('m_risk_rank')) { // only show Marietta's ranked properties
      return x.set('visible', true).set('cty_tmk', x.get('properties').get('cty_tmk')).set('data', state.get('filteredData').filter(y => y.get('cty_tmk') === x.get('properties').get('cty_tmk')).get(0))
    } else {
      return x.set('visible', false).set('cty_tmk', x.get('properties').get('cty_tmk')).set('data', state.get('data').filter(y => y.get('cty_tmk') === x.get('properties').get('cty_tmk')).get(0))
    }
  })
  return state.set('filteredProperties', filteredProperties)
}

/* * * * * * * * * Property Stats Calculator * * * * * * * * */
/*const calcStats = (data) => {
  return data.groupBy( (row) => row.get('property')).map((row, index) => {
    let results = row.map((row) => row.get('result') ? parseFloat(row.get('result')): null);
    let resultsNoNulls = results.filter((num) => num !== null);
    let resultsJS = results.toJS();
    let mean = d3.mean(resultsJS);
    let median = d3.median(resultsJS);
    let max = d3.max(resultsJS);
    let min = d3.min(resultsJS);
    return Map({min: min, max: max, mean: mean, median: median, sampleSize: resultsNoNulls.size});
  }).filter( (row) => row.get('max'));
}*/

/* * * * * * * * * Adding Stats to Properties & Filtering out Properties w/o Stats * * * * * * * * */
/*const calculateProperties = (state, action) => {
  // Calculate the stats
  var dataStats = calcStats(state.get('filteredData'))
  var latitudes = [],
      longitudes = [];
  // Attach dataStats above to properties, set visible=false if no stats for that property (i.e. no data)
  var filteredProperties = state.get('properties').map( (property) => {
    let stats = dataStats.get(property.get('property'))
    if(stats) {
      latitudes.push(parseFloat(property.get('latitude'), 10))
      longitudes.push(parseFloat(property.get('longitude'), 10))
      return property.set('visible', true).merge(stats)
    } else {
      return property.set('visible', false)
    }
  })
  var extent = List();
  // rough calculation of height and width of properties extent as a rectangle
  // based on https://en.wikipedia.org/wiki/Decimal_degrees - 90 m per 0.001 dd
  if(latitudes.length > 0) {
    var latitudeRange = d3.extent(latitudes.filter(x => x !== null))
    var longitudeRange = d3.extent(longitudes.filter(x => x !== null))
    var w = (latitudeRange[1] - latitudeRange[0]) * 90 // width in kilometers of data extent
    var l = (longitudeRange[1] - longitudeRange[0]) * 90 // length in kilometers of data extent
    extent = fromJS([w,l])
  } 
  return state.set('filteredProperties', filteredProperties).set('filteredPropertiesDimensions', extent)
}*/


/* * * * * * * * * Set Filtered Property Selection Data for LocPlot * * * * * * * * */
/*const setSelectedPropertyResults = (state, action) => {
  let results = state.get('filteredData').filter((row) => row.get('property') === state.get('selectedProperty'))
    .map((row) => Map({'result':parseFloat(row.get('result')), 'date':row.get('sample_date'),  'detect': (['Nondetect'].indexOf(row.get('detect_status')) < 0 ? '' : '<')}))
    .sort((a,b) => {
      let aDate = moment(a.get('sample_date'), 'll').toDate()
      let bDate = moment(b.get('sample_date'), 'll').toDate()
      return aDate > bDate ? -1 : 1
  })
  return state.set('selectedPropertyResults', results);
}*/

/* * * * * * * * * Set Static Property Selection Data for LocPlot * * * * * * * * */
/*const setSelectedPropertyStaticResults = (state, action) => {
  let results = state.get('data').filter((row) => 
    row.get('property') === state.get('selectedProperty') && row.get('matrix') === action.matrix && row.get('unit') === action.unit 
  ).map((row) => Map({'result':parseFloat(row.get('result')), 'date':row.get('sample_date'),  'detect': (['Nondetect'].indexOf(row.get('detect_status')) < 0 ? '' : '<')}))
      .sort((a,b) => {
        let aDate = moment(a.get('sample_date'), 'll').toDate()
        let bDate = moment(b.get('sample_date'), 'll').toDate()
        return aDate > bDate ? -1 : 1
      })
  return state.set('selectedPropertyStaticResults', results);
}*/

/* * * * * * * * * Highlight Properties * * * * * * * * */
const highlightProperties = (state, action) => {
  var highlightedProperties,
      selectedStat = action.radius === 'property' ? 'max' : action.radius,
      maxVal = state.get('filteredProperties').map((row) => row.get(selectedStat)).filter((row) => row !== null && row !== undefined).max();
  highlightedProperties = state.get('filteredProperties').map((row) => {
    let val = row.get(selectedStat)
    let inInterval = (val >= action.x0 && val < action.x1) || (val === action.x1 && val === maxVal);
    return row.set('highlight', inInterval)
  })
  return state.set('filteredProperties', highlightedProperties)
}

let initialState = Map({
  "data" : List(),
  "properties" : List(),
  "filteredData" : List(),
  "filteredProperties": List(),
  "selectedProperty": null,
  "selectedPropertyResults": List()
});

const DataApp = (state = initialState, action) => {

  switch(action.type){

    case "ERROR":
      return state.set('errorMessage', action.message)

    case "CLEAR_ERROR_MESSAGE":
      return state.set('errorMessage', null)

    case "RECEIVE_DATA":
      return state.set('data', fromJS(action.data.data))
        .set('properties', fromJS(JSON.parse(action.data.properties)))
        .set('selectedProperty', null)
        .set('errorMessage', null)

    case "FILTER_DATA":
      let stateWithFilteredData = applyFilters(state, action)  // filters data and assigns 'filteredData' in state
      //let stateWithFilteredProperties = calculateProperties(stateWithFilteredData, action) // assigns a summary stat to each property included in the 'filteredData'
      let stateWithFilteredProperties = applyFilteredData(stateWithFilteredData, action)
      //if(state.get('selectedProperty') !== null) {
      //  let stateWithSelectedFilteredData = setSelectedPropertyResults(stateWithFilteredProperties, action)
      //  return setSelectedPropertyStaticResults(stateWithSelectedFilteredData, action)
      //} else {
      return stateWithFilteredProperties
      //}

    case "CHOOSE_PROPERTY":
      if(state.get('selectedProperty') === action.property) {
        return state.set('selectedProperty', null)//.set('selectedPropertyResults', List())
      } else {
        return state.set('selectedProperty', action.property)
        //var stateWithSelectedProperty = state.set('selectedProperty', action.property)
        //return setSelectedPropertyResults(stateWithSelectedProperty, action);
      }

    case "CHOOSE_HISTOGRAM":
      var histogramSelection = action.x0 === state.get('histogramSelection') ? null : [action.x0, action.x1];
      if(histogramSelection !== null) {
        return highlightProperties(state, action);
      } else {
        return state.get('filteredProperties').map((row) => row.set('highlight', false))
      }

    case "CHOOSE_RADIUS":
      return state.set('filteredProperties', state.get('filteredProperties').map((row) => row.set('highlight', false)))


    default:
      return state
  }
}

export default DataApp;


// WEBPACK FOOTER //
// ./src/reducers/data.js